export const createUUID = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c, r) =>
  ('x' === c ? (r = Math.random() * 16 | 0) : (r & 0x3 | 0x8)).toString(16));


export const getNonUniqueIndices = <T, K extends keyof T>(
  parameter: Array<T>,
  key: K
): Array<number> => {
  const countMap = parameter.reduce((acc, item, index) => {
    const fieldValue = item[key] as unknown as string;
    if (!acc[fieldValue]) {
      acc[fieldValue] = { count: 0, indices: [] };
    }
    acc[fieldValue].count += 1;
    acc[fieldValue].indices.push(index);
    return acc;
  }, {} as Record<string, { count: number; indices: number[] }>);

  return Object.values(countMap)
    .filter((entry) => entry.count > 1)
    .flatMap((entry) => entry.indices);
};